/* ========================================================
   SENPAI DRIP - PREMIUM FEATURES JS
   Create this as a new asset file: senpai-premium.js
   ======================================================== */

document.addEventListener('DOMContentLoaded', function() {

  /* ========== 1. CUSTOM CURSOR (Desktop Only) ========== */
  if (window.innerWidth > 768 && !('ontouchstart' in window)) {
    var dot = document.createElement('div');
    dot.className = 'sd-cursor-dot';
    var ring = document.createElement('div');
    ring.className = 'sd-cursor-ring';
    document.body.appendChild(dot);
    document.body.appendChild(ring);

    var mouseX = 0, mouseY = 0;
    var ringX = 0, ringY = 0;

    document.addEventListener('mousemove', function(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.left = mouseX + 'px';
      dot.style.top = mouseY + 'px';
    });

    function animateRing() {
      ringX += (mouseX - ringX) * 0.15;
      ringY += (mouseY - ringY) * 0.15;
      ring.style.left = ringX + 'px';
      ring.style.top = ringY + 'px';
      requestAnimationFrame(animateRing);
    }
    animateRing();

    var hoverTargets = document.querySelectorAll('a, button, [role="button"], .product-card, .card-wrapper, input[type="submit"]');
    hoverTargets.forEach(function(el) {
      el.addEventListener('mouseenter', function() { ring.classList.add('sd-cursor-hover'); });
      el.addEventListener('mouseleave', function() { ring.classList.remove('sd-cursor-hover'); });
    });
  }


  /* ========== 2. SMOOTH PAGE TRANSITIONS ========== */
  var transitionOverlay = document.createElement('div');
  transitionOverlay.className = 'sd-page-transition';
  document.body.appendChild(transitionOverlay);

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') ||
        href.startsWith('javascript:') || link.target === '_blank' || link.hasAttribute('data-no-transition') ||
        e.ctrlKey || e.metaKey || e.shiftKey) return;

    if (link.hostname && link.hostname !== window.location.hostname) return;

    e.preventDefault();
    transitionOverlay.classList.add('sd-transition-active');

    setTimeout(function() {
      window.location.href = href;
    }, 350);
  });


  /* ========== 6. PARALLAX SCROLLING ON BANNERS ========== */
  var bannerImages = document.querySelectorAll('.banner img, .slideshow img, .image-banner img, [class*="hero"] img, [class*="banner"] img');
  bannerImages.forEach(function(img) {
    var parent = img.closest('.banner, .slideshow, .image-banner, [class*="hero"], [class*="banner"]');
    if (parent) {
      parent.classList.add('sd-parallax');
    }
  });

  function updateParallax() {
    var parallaxEls = document.querySelectorAll('.sd-parallax img');
    parallaxEls.forEach(function(img) {
      var rect = img.parentElement.getBoundingClientRect();
      var scrollPercent = (rect.top + rect.height) / (window.innerHeight + rect.height);
      var translateY = (scrollPercent - 0.5) * -40;
      img.style.transform = 'translateY(' + translateY + 'px)';
    });
  }

  var parallaxTicking = false;
  window.addEventListener('scroll', function() {
    if (!parallaxTicking) {
      requestAnimationFrame(function() {
        updateParallax();
        parallaxTicking = false;
      });
      parallaxTicking = true;
    }
  }, { passive: true });


  /* ========== 11. SOCIAL PROOF TICKER ========== */
  var proofMessages = [
    { city: 'Los Angeles, CA', product: 'Itachi Embroidered Heavyweight Tee', time: 'Just now' },
    { city: 'New York, NY', product: 'Zoro Embroidered Heavyweight Tee', time: '2 minutes ago' },
    { city: 'Toronto, ON', product: 'Majin Vegeta Snow Wash Black Tee', time: '4 minutes ago' },
    { city: 'London, UK', product: 'Sun-Faded Hoodie', time: '6 minutes ago' },
    { city: 'Miami, FL', product: 'Senpai Polo Shirt', time: '9 minutes ago' },
    { city: 'Dubai, UAE', product: 'Itachi Embroidered Heavyweight Tee', time: '12 minutes ago' },
    { city: 'Sydney, AU', product: 'Zoro Embroidered Heavyweight Tee', time: '15 minutes ago' },
    { city: 'Chicago, IL', product: 'Majin Vegeta Snow Wash Black Tee', time: '18 minutes ago' },
    { city: 'Vancouver, BC', product: 'Sun-Faded Hoodie', time: '22 minutes ago' },
    { city: 'Houston, TX', product: 'Senpai Polo Shirt', time: '25 minutes ago' },
    { city: 'Berlin, DE', product: 'Itachi Embroidered Heavyweight Tee', time: '29 minutes ago' },
    { city: 'Tokyo, JP', product: 'Zoro Embroidered Heavyweight Tee', time: '33 minutes ago' },
    { city: 'Paris, FR', product: 'Majin Vegeta Snow Wash Black Tee', time: '37 minutes ago' },
    { city: 'Seoul, KR', product: 'Sun-Faded Hoodie', time: '41 minutes ago' },
    { city: 'Atlanta, GA', product: 'Senpai Polo Shirt', time: '45 minutes ago' },
    { city: 'Manchester, UK', product: 'Itachi Embroidered Heavyweight Tee', time: '49 minutes ago' },
    { city: 'Melbourne, AU', product: 'Zoro Embroidered Heavyweight Tee', time: '53 minutes ago' },
    { city: 'Mexico City, MX', product: 'Majin Vegeta Snow Wash Black Tee', time: '57 minutes ago' },
    { city: 'Amsterdam, NL', product: 'Sun-Faded Hoodie', time: '1 hour ago' },
    { city: 'Singapore, SG', product: 'Senpai Polo Shirt', time: '1 hour ago' },
    { city: 'San Francisco, CA', product: 'Itachi Embroidered Heavyweight Tee', time: '1 hour ago' },
    { city: 'Austin, TX', product: 'Zoro Embroidered Heavyweight Tee', time: '2 hours ago' },
    { city: 'Montreal, QC', product: 'Majin Vegeta Snow Wash Black Tee', time: '2 hours ago' },
    { city: 'Osaka, JP', product: 'Sun-Faded Hoodie', time: '2 hours ago' },
    { city: 'Brooklyn, NY', product: 'Senpai Polo Shirt', time: '3 hours ago' }
  ];

  var proofPopup = document.createElement('div');
  proofPopup.className = 'sd-social-proof';
  proofPopup.innerHTML =
    '<button class="sd-social-proof-close">&times;</button>' +
    '<div class="sd-social-proof-header">' +
      '<div class="sd-social-proof-dot"></div>' +
    '<span class="sd-social-proof-label">Recently Bought</span>' +
    '</div>' +
    '<div class="sd-social-proof-text"></div>' +
    '<div class="sd-social-proof-time"></div>';
  document.body.appendChild(proofPopup);

  var proofIndex = Math.floor(Math.random() * proofMessages.length);
  var proofClosed = false;

  proofPopup.querySelector('.sd-social-proof-close').addEventListener('click', function() {
    proofPopup.classList.remove('sd-proof-visible');
    proofClosed = true;
  });

  function showProof() {
    if (proofClosed) return;
    var msg = proofMessages[proofIndex % proofMessages.length];
    proofPopup.querySelector('.sd-social-proof-text').innerHTML =
    'Someone in <strong>' + msg.city + '</strong> just bought the <strong>' + msg.product + '</strong>';
    proofPopup.querySelector('.sd-social-proof-time').textContent = msg.time;
    proofPopup.classList.add('sd-proof-visible');

    setTimeout(function() {
      proofPopup.classList.remove('sd-proof-visible');
      proofIndex++;
    }, 5000);
  }

  // Show first proof after 8 seconds, then every 35 seconds
  setTimeout(function() {
    showProof();
    setInterval(function() {
      showProof();
    }, 35000);
  }, 8000);


  /* ========== 14. COUNTDOWN TIMER ========== */
  var RESET_MS = 12 * 24 * 60 * 60 * 1000; // 12 days
  var STORAGE_KEY = 'sd_drop_end';
  var stored = parseInt(localStorage.getItem(STORAGE_KEY), 10);
  var dropDate;
  if (stored && stored > Date.now()) {
    dropDate = stored;
  } else {
    dropDate = Date.now() + RESET_MS;
    localStorage.setItem(STORAGE_KEY, dropDate);
  }

  var countdownSection = document.querySelector('.sd-countdown');
  if (!countdownSection) {
    var isHomepage = window.location.pathname === '/' || window.location.pathname === '';
    if (isHomepage) {
      var mainContent = document.querySelector('#MainContent');
      if (mainContent && mainContent.firstElementChild) {
        var countdownDiv = document.createElement('div');
        countdownDiv.className = 'sd-countdown';
        countdownDiv.innerHTML =
          '<div class="sd-countdown-label">THE NEXT DROP IS COMING</div>' +
          '<div class="sd-countdown-timer">' +
            '<div class="sd-countdown-block"><div class="sd-countdown-number" id="sd-days">00</div><div class="sd-countdown-unit">Days</div></div>' +
            '<div class="sd-countdown-separator">:</div>' +
            '<div class="sd-countdown-block"><div class="sd-countdown-number" id="sd-hours">00</div><div class="sd-countdown-unit">Hours</div></div>' +
            '<div class="sd-countdown-separator">:</div>' +
            '<div class="sd-countdown-block"><div class="sd-countdown-number" id="sd-mins">00</div><div class="sd-countdown-unit">Mins</div></div>' +
            '<div class="sd-countdown-separator">:</div>' +
            '<div class="sd-countdown-block"><div class="sd-countdown-number" id="sd-secs">00</div><div class="sd-countdown-unit">Secs</div></div>' +
          '</div>';

        var firstSection = mainContent.children[1] || mainContent.firstElementChild;
        firstSection.parentNode.insertBefore(countdownDiv, firstSection.nextSibling);
        countdownSection = countdownDiv;
      }
    }
  }

  function updateCountdown() {
    var now = new Date().getTime();
    var diff = dropDate - now;

    if (diff <= 0) {
      dropDate = Date.now() + RESET_MS;
      localStorage.setItem(STORAGE_KEY, dropDate);
      return;
    }
    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var secs = Math.floor((diff % (1000 * 60)) / 1000);

    if (document.getElementById('sd-days')) {
      document.getElementById('sd-days').textContent = days < 10 ? '0' + days : days;
      document.getElementById('sd-hours').textContent = hours < 10 ? '0' + hours : hours;
      document.getElementById('sd-mins').textContent = mins < 10 ? '0' + mins : mins;
      document.getElementById('sd-secs').textContent = secs < 10 ? '0' + secs : secs;
    }
  }

  if (countdownSection || window.location.pathname === '/') {
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }


  /* ========== 16. "SEE IT ON" POPUP (Product Pages) ========== */
  var productFormCheck = document.querySelector('form[action*="/cart/add"]');
  if (productFormCheck) {
    var allProductImages = document.querySelectorAll('.product__media-item img, .product-single__media img, .product__media img');

    if (allProductImages.length >= 2) {

      var seeItOnBtn = document.createElement('button');
      seeItOnBtn.className = 'sd-see-it-on-trigger';
      seeItOnBtn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/><path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7Z"/></svg>' +
        '<span>SEE IT ON</span>';

      var productFormParent = productFormCheck.parentElement;
      if (productFormParent) {
        productFormParent.insertBefore(seeItOnBtn, productFormCheck);
      }

      var galleryImages = '';
      var thumbImages = '';
      allProductImages.forEach(function(img, index) {
        var src = img.src || img.getAttribute('data-src') || '';
        if (src) {
          galleryImages += '<div class="sd-see-slide' + (index === 0 ? ' sd-see-slide-active' : '') + '"><img src="' + src + '" alt="Model photo ' + (index + 1) + '"></div>';
          thumbImages += '<div class="sd-see-thumb' + (index === 0 ? ' sd-see-thumb-active' : '') + '" data-index="' + index + '"><img src="' + src + '" alt="Thumb ' + (index + 1) + '"></div>';
        }
      });

      var seeItOnOverlay = document.createElement('div');
      seeItOnOverlay.className = 'sd-see-overlay';
      seeItOnOverlay.innerHTML =
        '<div class="sd-see-modal">' +
          '<button class="sd-see-close">&times;</button>' +
          '<div class="sd-see-header">' +
            '<h3>SEE IT ON</h3>' +
            '<p>Swipe through to see the fit on different angles</p>' +
          '</div>' +
          '<div class="sd-see-gallery">' +
            '<button class="sd-see-arrow sd-see-prev">&#8249;</button>' +
            '<div class="sd-see-slides">' + galleryImages + '</div>' +
            '<button class="sd-see-arrow sd-see-next">&#8250;</button>' +
          '</div>' +
          '<div class="sd-see-thumbs">' + thumbImages + '</div>' +
          '<div class="sd-see-details">' +
            '<div class="sd-see-detail-item"><span class="sd-see-detail-label">FIT</span><span class="sd-see-detail-value">Oversized / Boxy</span></div>' +
            '<div class="sd-see-detail-item"><span class="sd-see-detail-label">MODEL</span><span class="sd-see-detail-value">6\'1" / 185cm — Wearing Size L</span></div>' +
            '<div class="sd-see-detail-item"><span class="sd-see-detail-label">FABRIC</span><span class="sd-see-detail-value">400 GSM Heavyweight</span></div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(seeItOnOverlay);

      var currentSlide = 0;
      var slides = seeItOnOverlay.querySelectorAll('.sd-see-slide');
      var thumbs = seeItOnOverlay.querySelectorAll('.sd-see-thumb');

      function goToSlide(index) {
        slides.forEach(function(s) { s.classList.remove('sd-see-slide-active'); });
        thumbs.forEach(function(t) { t.classList.remove('sd-see-thumb-active'); });
        currentSlide = index;
        if (currentSlide >= slides.length) currentSlide = 0;
        if (currentSlide < 0) currentSlide = slides.length - 1;
        slides[currentSlide].classList.add('sd-see-slide-active');
        thumbs[currentSlide].classList.add('sd-see-thumb-active');
      }

      seeItOnOverlay.querySelector('.sd-see-next').addEventListener('click', function() {
        goToSlide(currentSlide + 1);
      });
      seeItOnOverlay.querySelector('.sd-see-prev').addEventListener('click', function() {
        goToSlide(currentSlide - 1);
      });

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          goToSlide(parseInt(this.getAttribute('data-index')));
        });
      });

      seeItOnBtn.addEventListener('click', function() {
        seeItOnOverlay.classList.add('sd-see-open');
        document.body.style.overflow = 'hidden';
      });

      seeItOnOverlay.querySelector('.sd-see-close').addEventListener('click', function() {
        seeItOnOverlay.classList.remove('sd-see-open');
        document.body.style.overflow = '';
      });
      seeItOnOverlay.addEventListener('click', function(e) {
        if (e.target === seeItOnOverlay) {
          seeItOnOverlay.classList.remove('sd-see-open');
          document.body.style.overflow = '';
        }
      });

      document.addEventListener('keydown', function(e) {
        if (!seeItOnOverlay.classList.contains('sd-see-open')) return;
        if (e.key === 'Escape') {
          seeItOnOverlay.classList.remove('sd-see-open');
          document.body.style.overflow = '';
        }
        if (e.key === 'ArrowRight') goToSlide(currentSlide + 1);
        if (e.key === 'ArrowLeft') goToSlide(currentSlide - 1);
      });
    }
  }


  /* ========== 15. LOYALTY POINTS BADGE (Product Pages) ========== */
  if (productFormCheck) {
    var priceEl = document.querySelector('.price__regular .price-item, .product__price, .price-item--regular');
    if (priceEl) {
      var priceText = priceEl.textContent.trim();
      var priceNum = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      if (priceNum > 0) {
        var points = Math.floor(priceNum * 10);
        var badge = document.createElement('div');
        badge.className = 'sd-loyalty-badge';
        badge.innerHTML =
          '<span class="sd-loyalty-icon">&#9733;</span>' +
          '<span class="sd-loyalty-text">You earn <span class="sd-loyalty-points">' + points + ' Drip Points</span> with this piece</span>';

        var priceContainer = priceEl.closest('.price') || priceEl.parentElement;
        if (priceContainer) {
          priceContainer.parentNode.insertBefore(badge, priceContainer.nextSibling);
        }
      }
    }
  }

});